// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2Lf63","icon":"Button_icon__36xd-","button-primary":"Button_button-primary__1rm1L","button-secondary":"Button_button-secondary__2Cktx"};